import React, { useEffect } from "react";
import ReactGA from "react-ga4";

// components
// import Navbar from "../components/navbar/Navbar";
import TeamHeader from "../components/team/TeamHeader";
import Team from "../components/team/Team";
import PreFooter from "../components/pre-footer/PreFooter";
import Footer from "../components/footer/Footer";

const TeamWrapper = () => {
  useEffect(() => {
    const currentPage = window.location.pathname;
    ReactGA.send({
      hitType: "pageview",
      page: "/team",
      title: "team",
    });
    // console.log("GA Page View Sent:", currentPage); // Debugging
  }, []);
  return (
    <>
      {/* <Navbar /> */}
      <TeamHeader />
      <Team />
      <PreFooter />
      <Footer />
    </>
  );
};

export default TeamWrapper;
